<template>
    <b-row>
        <b-col cols="12" md="6">
            <b-card>
                <b-form-group :label="$t('name')">
                    <protokol-invalid-feedback :errors="validator.fieldErrors('name')">
                        <b-input v-model="name" />
                    </protokol-invalid-feedback>
                </b-form-group>

                <b-button @click="save" variant="success"> {{ $t('save') }} </b-button>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>

export default {
    name: 'FunctionCreate',
    components: {},
    data: function () {
        return {
            validator: this.$validator(),
            model: {
                name: ""
            }
        }
    },

    watch: {
        model: {
            handler: function () {
                this.validator.revalidate()
            },

            deep: true
        },
    },

    computed: {
        name: {
            get() {
                return this.model.name.replaceAll(" ", "_").replaceAll(/[0-9]/g, "")
            },

            set(val) {
                this.model.name = val.replaceAll(" ", "_").replaceAll(/[0-9]/g, "")
            }
        }
    },
    methods: {
        save() {
            if (!this.validator.pass()) return

            let popup = this.$loadingPopup()
            this.$functions.create(this.model).then((resp) => {
                this.$router.push(`/admin/functions/${resp.data.uuid}`)
            }).catch(err => {
                console.error(err)
                
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            }).finally(() => {
                popup.hide()
            })
        }
    },

    created() {
        const jsReservedKeywords = [
            'break','case','catch','class','const','continue','debugger','default',
            'delete','do','else','export','extends','false','finally','for',
            'function','if','import','in','instanceof','let','new','null',
            'return','static','super','switch','this','throw','true','try',
            'typeof','undefined','var','void','while','with','yield','enum','await'
        ]
        this.validator.validate(this.model, {
            isValidDNSName: (model, errors) => {
                if (model.name.length < 1) {
                    errors.add('name', [this.$t('requiredField')])
                    return
                }

                if (model.name.length < 3) {
                    errors.add('name', [this.$t('notValid')])
                    return
                }

                if (jsReservedKeywords.includes(model.name.toLowerCase())) {
                    errors.add('name', [this.$t('functionNameReservedKeyword')])
                }
            },
        })
    }
}
</script>
